<template>
  <div class="u-relative u-pad-x-w1of12">
     <div class="u-relative">
        <ul class="c-partners-slideshow__grid o-list--none o-list--inline u-align-left"   v-for="(item, index)  in partnersArray"   :class="{'u-relative is-first':(0===index),'u-absolute u-pos-tl u-fit':(0!=index),'is-active':activeSlidePartners ===index}" >
           <li class="c-partners-slideshow__grid__item o-list__item o-box--6by10 u-force-3d u-w1of4 u-w1of2@sm" v-for="(Ppanel, index)  in item.panel" >
              <div class="o-wrapper--panel o-wrapper--valign u-align-center u-fit">
                <img src="Ppanel.logotype.url" alt="Ppanel.logo.name" class="c-partners-slideshow__grid__item__logo u-inline-block u-valign-middle">
              </div>
           </li>
       </ul>
      </div>
     <div class="u-relative u-pad-y-lg">
        <!---->
        <ul class="o-list o-list--inline u-absolute u-pos-center">
           <li   v-for="(item, index)  in partnersArray"  class="c-partners-slideshow__dot o-list__item u-bg--gray u-shape-circle u-cursor-pointer"  :class="{'u-marg-r-sm':(partnersArray.length-1!=index),'is-active':activeSlidePartners ===index}"  @click="onChangeIndexTo(item)"></li>
      </ul>
          <button class="t-btn t-link--opacity t-text--sm u-color--gray u-absolute u-pos-r u-pos-y-center" v-if="activeSlidePartners > 0" @click="onPrevSlidePartners">{{ content.en.partners.previous_label }}</button>
          <button class="t-btn t-link--opacity t-text--sm u-color--gray u-absolute u-pos-r u-pos-y-center" v-if="activeSlidePartners < t.activeSlidePartnersMaximum" @click="onNextSlidePartners">{{ content.en.partners.next_label}}</button>
     </div>
  </div>
</template>
<script>
export default {
  name: "app-partners-slideshow",
                  props: {
                    debug: {
                        type: Boolean,
                        default: !1
                    },
                      content: {
                          type: Object,
                          default: function() {}
                      }
                  },
                  data: function() {
                      return {
                          partnersArray: new Array(),
                          activeSlidePartners: 0
                      }
                  },
                  mounted: function()
                  {
                    var t = this.content.en.partners.list, e = -1;
                      for (n = 0; n < Math.ceil(t.length / 12); n += 1) this.partnersArray.push({
                          panel: new Array()
                      });
                      for (var r = 0; r < t.length; r += 1)
                      r % 12 == 0 ? (e += 1, this.partnersArray[e].panel.push({ logo: t[r]  })) : this.partnersArray[e].panel.push({
                          logo: t[r]
                      });
                      this.activeSlidePartnersMaximum = e
                  },
                  methods:
                  {
                      onChangeIndexTo: function(t)
                      {
                          t >= 0 && t <= this.partnersArray.length - 1 && (this.activeSlidePartners = t)
                      },
                      onPrevSlidePartners: function()
                       {
                          this.activeSlidePartners > 0 && (this.activeSlidePartners -= 1)
                      },
                      onNextSlidePartners: function()
                      {
                          this.activeSlidePartners < this.partnersArray.length - 1 && (this.activeSlidePartners += 1)
                      }
                  }
}
</script>
<style  scoped>
</style>
